import { render } from "./SpecificationCheckbox.vue?vue&type=template&id=85bdbf6c"
import script from "./SpecificationCheckbox.vue?vue&type=script&lang=js"
export * from "./SpecificationCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__